import React, { createContext, useContext } from "react"

/* Ensures that you don't try calling the returned useSafeContext without the related Provider */
export const createSafeContext = <ContextValue,>(errorMessage: string) => {
    const Context = createContext<ContextValue | null>(null)

    const useSafeContext = () => {
        const ctx = useContext(Context)

        if (ctx === null) {
            throw new Error(errorMessage)
        }

        return ctx
    }

    const Provider = ({ children, value }: { value: ContextValue; children: React.ReactNode }) => (
        <Context.Provider value={value}>{children}</Context.Provider>
    )

    return [Provider, useSafeContext] as const
}
